var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-fill justify-center"},[_c('fe-empty-state',{attrs:{"icon":"fa-empty-set","text":"Sorry, that page was not found or you do not have permission to access it"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }